import React from 'react';
import './style/copyToClipboard.css';
import './style/shareComponent.css';
import CopyToClipboard from './copyToClipboard';
import Icon from '../../../jo-components/ui/icon/icon';
import HTMLContent from './../../../../components/htmlContent';
import Modal from '../../../jo-components/ui/modal/modal';

const SHARE_PLATFORMS = [
    {
        title: 'SMS',
        icon: 'sms',
        getUrl: (text) => `sms:?body=${text}`
    },
    {
        title: 'Email',
        icon: 'sendMail',
        getUrl: (text, title) => `mailto:?subject=${title}&body=${text}`
    },
    {
        title: 'WhatsApp',
        icon: 'whatsapp',
        getUrl: (text) => `https://wa.me/?text=${text}`
    },
    {
        title: 'Telegram',
        icon: 'telegram',
        getUrl: (text, title) => `https://t.me/share/url?url=${title}&text=${text}`
    }
];

function ShareIcon({ title, icon, url }) {
    const handleClick = React.useCallback(() => {
        window.open(url, '_blank', 'noopener,noreferrer');
    }, [url]);

    return (
        <div className='wz-share-icon' onClick={handleClick}>
            <Icon name={icon} size='huge' />
            <span className='wz-share-title'>{title}</span>
        </div>
    );
}

export default function ShareComponent({ 
    data, 
    onSubmit = () => {}, 
    showModal, 
    setShowModal = () => {} 
}) {

    const shareLinkAction = data?.resale_option?.share_link_action;

    if (!shareLinkAction || !shareLinkAction.action?.enabled) {
        return null;
    }

    const { 
        share_message_text, 
        share_message_title, 
        share_title, 
        share_description,
    } = shareLinkAction;

    if (!share_message_text || !share_message_title) {
        return null;
    }

    const { encodedText, encodedTitle } = React.useMemo(() => ({
        encodedText: encodeURIComponent(share_message_text),
        encodedTitle: encodeURIComponent(share_message_title)
    }), [share_message_text, share_message_title]);

    const handleCloseModal = React.useCallback(() => {
        setShowModal(false);
    }, [setShowModal]);

    if (!showModal) {
        return null;
    }

    return (
        <div className='wz-copy-to-clipboard'>
            <Modal 
                title={share_title} 
                subtitle={share_description ? <HTMLContent content={share_description} /> : null} 
                open={showModal} 
                onClose={handleCloseModal}
            >
                <CopyToClipboard data={data} />
                <div className='wz-share-options'>
                    <div className='wz-share-icons'>
                        {SHARE_PLATFORMS.map(platform => (
                            <ShareIcon
                                key={platform.title}
                                title={platform.title}
                                icon={platform.icon}
                                url={platform.getUrl(encodedText, encodedTitle)}
                            />
                        ))}
                    </div>
                </div>
            </Modal>
        </div>
    );
}